import Box from "@mui/material/Box";
import CampaignApprovalCommentsContent from "./CampaignApprovalCommentsContent";
import { INPUT_COLOR_BORDER } from "../../../../utils/colors";

const CampaignApprovalPanel = ({ approvalData, onChangeSectionSelected }) => {
  if (!approvalData?.enabled) {
    return null;
  }

  return (
    <Box
      sx={{
        width: "100%",
        maxWidth: { xs: "100%", md: 320 },
        minWidth: 320,
        height: { md: "100%" },
        maxHeight: { xs: "50vh", md: "100%" },
        minHeight: 0,
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
        borderLeft: `1px solid ${INPUT_COLOR_BORDER}`,
        bgcolor: "background.paper",
        py: { xs: 1.5, md: 2.5 },
        pl: 1.5,
        pr: 1,
      }}
    >
      <CampaignApprovalCommentsContent
        approvalData={approvalData}
        onChangeSectionSelected={onChangeSectionSelected}
      />
    </Box>
  );
};

export default CampaignApprovalPanel;
